// react
// dependencies
import { List } from "immutable";
import React from "react";
import { connect } from "react-redux";

import TextInput from "../../../components/Inputs/TextInput";
import ProgressBar from "../../../components/ProgressBar";
// components
import Goal from "./components/Goal";

// actions
import { initialize } from "./actions";

// selectors
import { getAppWidth } from "../../../selectors/app";
import { getGoalName, getGoals } from "./selectors";

import PropTypes from "../../../lib/prop-types";

// styles
import css from "./style.module.scss";

export class ViewCreateGoalsJob extends React.Component {
	static propTypes = {
		initialize: PropTypes.func.isRequired,
		goalName: PropTypes.string.isRequired,
		tableWidth: PropTypes.number.isRequired,
		rows: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {};

	componentDidMount() {
		this.props.initialize();
	}

	render() {
		const { goalName, rows, tableWidth } = this.props;

		if (rows.size === 0) {
			return <div />;
		}

		return (
			<section className={css.viewGoalJobPage} style={{}}>
				<section className="page-wrapper" style={{ width: tableWidth }}>
					<div className="page-title">Created Goals</div>
					<div className="page-description">
						Producer Gorgeous Metal Car syndicate needs-based Human silver teal definition interface
						application transform Bike sticky Consultant deposit
					</div>

					<div className="progress-bar-wrapper">
						<ProgressBar width={600} progress={20} />
					</div>

					<div className="goal-information">
						<div className="input-label">Goal Name</div>
						<div className="goal-name">{goalName}</div>
					</div>

					<div className="search-goals-wrapper">
						<div className="input-label">Search for a goal by assignee</div>
						<TextInput />
					</div>

					<section className="goals-list">
						{rows.map((row) => (
							<Goal
								key={row.get("id")}
								name={row.get("name")}
								id={row.get("id")}
								assigneeName={row.get("assigneeName")}
								assigneeID={row.get("assigneeID")}
							/>
						))}
					</section>
				</section>
			</section>
		);
	}
}

const mapStateToProps = (state) => ({
	rows: getGoals(state),
	goalName: getGoalName(state),
	tableWidth: getAppWidth(state) - 60,
});

const mapDispatchToProps = (dispatch) => ({
	initialize: () => dispatch(initialize()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewCreateGoalsJob);
